/* eslint-disable eqeqeq */
import { orderBy } from 'lodash';
import { convHasUnreadMessages } from '../utils/messaging';

export function resolveSelectedConv(state, incomingConvs) {
    if (state.newConversation) {
        return undefined;
    }
    if (state.selectedConv) {
        return state.selectedConv;
    }
    if (state.suppressAutoSelect) {
        return null;
    }
    if (incomingConvs?.length) {
        return incomingConvs[0].id;
    }
    return null;
}

export function shouldShowUnreadNotification(conv, selectedConvId, inboxIsOpen) {
    if (!convHasUnreadMessages(conv)) {
        return false;
    }
    return !(inboxIsOpen && conv.id == selectedConvId);
}

export function hasAnyUnreadConv(convs, selectedConvId, inboxIsOpen) {
    return convs.some(conv => shouldShowUnreadNotification(conv, selectedConvId, inboxIsOpen));
}

// conv.messages is stored newest-first everywhere it is consumed — the inbox poll
// reads messages[0].created as its `after` cursor and the conversation-list preview
// renders messages[0] as the latest message (see Inbox/index.jsx). Rank on that same
// first element rather than scanning every message on each poll.
export function sortConvsByRecency(convs) {
    return orderBy(convs, conv => {
        const created = conv.messages?.[0]?.created;
        return created ? new Date(created).getTime() : 0;
    }, 'desc');
}

export function mergeIncomingConvs(existingConvs, incomingConvs, selectedConvId, inboxIsOpen) {
    const updatedConvs = [];
    let headerUnreadNotification = false;
    incomingConvs.forEach(incoming => {
        const match = existingConvs.find(c => c.id === incoming.id);
        if (match) {
            const existingIds = new Set(match.messages.map(m => m.id));
            const mergedMessages = [...match.messages, ...incoming.messages.filter(m => !existingIds.has(m.id))];
            updatedConvs.push({
                ...match,
                messages: orderBy(mergedMessages, 'created', 'desc'),
            });
        } else {
            updatedConvs.push(incoming);
        }
        if (shouldShowUnreadNotification(incoming, selectedConvId, inboxIsOpen)) {
            headerUnreadNotification = true;
        }
    });
    return { convs: updatedConvs, headerUnreadNotification };
}
